const key = "coupon"

export const createReferralLink = (couponCode: string) => {
  const url = new URL("/kiban/signup", window.location.origin)
  url.searchParams.append(key, couponCode)
  return url
}

export const getCouponCode = () => {
  if (typeof window === "undefined") {
    return null
  }
  return new URLSearchParams(window.location.search).get(key)
}
